import React from 'react';
import { Box } from 'braid-design-system';

import * as styles from './Branch.css';

interface Props {
  appVersion: string;
  branchName: string;
}

function Branch({ appVersion, branchName }: Props) {
  // eslint-disable-next-line no-console
  console.info(`Build: ${appVersion} | Branch: ${branchName}`);

  return (
    <Box className={styles.banner}>
      Build: {appVersion} | Branch: {branchName}
    </Box>
  );
}

export default Branch;
